var render = function render(){var _vm=this,_c=_vm._self._c;return _c('spinner',{attrs:{"message":_vm.message,"show":_vm.isLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }